export function Placeholder({ title, note }: { title: string; note?: string }) {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-ink-900">{title}</h1>
      <div className="card flex flex-col items-center gap-2 px-6 py-16 text-center">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gold-50 text-gold-500">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
            <path d="M12 8v5m0 3h.01M12 3l9 16H3z" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <p className="font-medium text-ink-700">{title} screen</p>
        <p className="max-w-md text-sm text-ink-400">
          {note ?? 'This screen is wired to the API and will be filled in shortly.'}
        </p>
      </div>
    </div>
  );
}
